import type { WorkflowAction, WorkflowTrigger } from "./types.ts";

export const WEEKDAYS = ["domingo", "segunda", "terça", "quarta", "quinta", "sexta", "sábado"];

/** "Quando um registro de pedidos é criado (filtro …)". */
export function triggerText(t: WorkflowTrigger): string {
  const filter = "filter" in t && t.filter ? ` e casa com ${JSON.stringify(t.filter)}` : "";
  switch (t.type) {
    case "record.created":
      return `Quando um registro de ${t.collection} é criado${filter}`;
    case "record.updated":
      return `Quando um registro de ${t.collection} é alterado${t.fields ? ` (${t.fields.join(", ")})` : ""}${filter}`;
    case "record.deleted":
      return `Quando um registro de ${t.collection} vai para a lixeira${filter}`;
    case "schedule": {
      const at = t.at ?? "08:00";
      if (t.every === "hour") return `A cada hora, aos ${String(t.minute ?? 0).padStart(2, "0")} minutos`;
      if (t.every === "day") return `Todo dia às ${at}`;
      if (t.every === "week") return `Toda ${WEEKDAYS[t.weekday ?? 1]} às ${at}`;
      return `Todo dia ${t.day ?? 1} do mês às ${at}`;
    }
    case "manual":
      return `Botão "${t.label ?? "Rodar"}"${t.collection ? ` num registro de ${t.collection}` : ""}${t.roles?.length ? `, também para ${t.roles.join(", ")}` : ""}`;
  }
}

export function actionText(a: WorkflowAction): string {
  const values = Object.entries(a.values)
    .map(([k, v]) => `${k} = ${valueText(v)}`)
    .join(", ");
  if (a.type === "record.create") return `Cria em ${a.collection}: ${values}`;
  return a.filter ? `Altera em ${a.collection} os que casam com ${JSON.stringify(a.filter)}: ${values}` : `Altera o próprio registro: ${values}`;
}

/** Expressions in plain Portuguese, literals as JSON. */
export function valueText(v: unknown): string {
  if (typeof v === "string") return JSON.stringify(v);
  if (typeof v !== "object" || v === null || Array.isArray(v)) return JSON.stringify(v);
  const entries = Object.entries(v);
  if (entries.length !== 1) return JSON.stringify(v);
  const [k, x] = entries[0]!;
  switch (k) {
    case "$field":
      return `campo ${String(x)} do gatilho`;
    case "$before":
      return `${String(x)} antes`;
    case "$current":
      return `${String(x)} atual`;
    case "$recordId":
      return "id do registro do gatilho";
    case "$now":
      return "agora";
    case "$today":
      return x === 0 ? "hoje" : `hoje ${(x as number) > 0 ? "+" : "−"} ${Math.abs(x as number)} dias`;
    case "$add":
    case "$sub":
    case "$mul":
      return `(${(x as unknown[]).map(valueText).join(k === "$add" ? " + " : k === "$sub" ? " − " : " × ")})`;
    default:
      return JSON.stringify(v);
  }
}
